module.exports = __webpack_public_path__ + "static/media/friendsnus.20c1970a.jpeg";